import { useTranslation } from 'react-i18next'
import useTotalBalance from '../../hooks/useTotalBalance'
import BaseBalanceCard from './BaseBalanceCard'

const TotalBalanceCard = () => {
  const { t } = useTranslation('wallet', { keyPrefix: 'assetCard' })

  const {
    goldBalanceInUsd,
    rwaBalanceInUsd,
    cryptoBalanceInUsd,
    totalBalanceInUsd,
    loading,
  } = useTotalBalance()

  return (
    <BaseBalanceCard
      loading={loading}
      title={t('total')}
      goldBalanceInUsd={goldBalanceInUsd}
      rwaBalanceInUsd={rwaBalanceInUsd}
      cryptoBalanceInUsd={cryptoBalanceInUsd}
      totalBalanceInUsd={totalBalanceInUsd}
    />
  )
}

export default TotalBalanceCard
